<template>
  <div class="announcements-page">
    <section class="section section--filters" v-if="currentUser">
      <div class="container">
        <div class="section__head">
          <h2>Ogłoszenia</h2>
        </div>

        <div class="search-announcement">
          <input
            type="text"
            placeholder="Szukane ogłoszenie"
            id="searchText"
            v-model="searchText"
            required>

          <select name="category" id="category" v-model="categorySelect" required @change="filterAnnouncementsByCategory">
            <option value="">-- wybierz kategorię --</option>
            <option>sprzedaż</option>
            <option>współpraca</option>
            <option>wymiana</option>
            <option>inne</option>
          </select>

          <div class="target-choose">
            <select name="target" id="target" v-model="targetSelect" @change="getAnnouncements" required>
              <option>do wszystkich</option>
              <option>do specjalistów</option>
              <option>do właścicieli zwierząt</option>
            </select>
          </div>

          <button class="filter-btn filter-btn--primary" @click="searchAnnouncement">Szukaj</button>
          <button
            class="filter-btn"
            @click="() => {
              getAnnouncements();
              searchText = '';
              hidePages = false;
            }">
            Resetuj
          </button>
        </div>
      </div>
    </section>

    <section class="section section--content" v-if="currentUser">
      <div class="container">
        <div class="announcement-page" v-if="! hidePages">
          <div class="announcement-pagination">
            <button class="announcement-pagination__arrow" @click="() => {
              if (page > 1) {
                page -= 1;
                getAnnouncements();
              }
            }" :disabled="page <= totalPages">‹</button>
            <span>{{ page }} / {{ totalPages }}</span>
            <button class="announcement-pagination__arrow" @click="() => {
              if (page < totalPages) {
                page += 1;
                getAnnouncements();
              }
            }" :disabled="page >= totalPages">›</button>
          </div>
        </div>

        <div class="announcements-container" v-if="filteredAnnouncements.length > 0">
          <AnnouncementCardVue
            :show-active="false"
            v-for="announcement in filteredAnnouncements"
            :contact="announcement.contact"
            :target="announcement.target"
            :category="announcement.category"
            :key="announcement.id"
            :img="announcement.photo_url"
            :longContent="announcement.description"
            :id="announcement.id"
            :title="announcement.title"
            :content="announcement.short_description"
            :photo="announcement.photo"
          />
        </div>

        <div v-else class="empty-state">
          <div class="empty-state__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" role="img" focusable="false">
              <path d="M10 4h8a2 2 0 0 1 2 2v11a3 3 0 0 1-3 3H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h2zm0 2H8a2 2 0 0 0-2 2v8a2 2 0 1 0 4 0V6zm3 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2zm0 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2z"/>
            </svg>
          </div>
          <h3>Brak ogłoszeń</h3>
          <p>Spróbuj zmienić filtry lub wpisz inną frazę wyszukiwania.</p>
        </div>
      </div>
    </section>

    <section class="section" v-else>
      <div class="container">
        <div class="not-logged-in">
          <h2>Zaloguj się, aby przeglądać ogłoszenia</h2>
          <p>Aby dodać ogłoszenie, załóż konto.</p>
          <div>
            <ButtonVue text="Zaloguj się" bg-color="#10b981" color="#fff" @click="() => $router.push('/login')" />
            <ButtonVue text="Zarejestruj się" bg-color="#10b981" color="#fff" @click="() => $router.push('/register')" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import ButtonVue from '@/components/Button.vue'
import AnnouncementCardVue from '@/components/SpecialComponents/AnnouncementCard.vue';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
export default{
  name: "AnnouncementsPage",
  setup () {
    useMeta({ title: 'Ogłoszenia' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    }
  },
  data () {
    return {
      targetSelect: localStorage.getItem('m2vetEntryMode') || 'do wszystkich',
      targetedAnnouncements: [],
      filteredAnnouncements: [],
      totalPages: 1,
      page: 1,
      announcementsCount: 0,
      searchText: '',
      hidePages: false,
      categorySelect: ''
    }
  },
  computed: {
    currentUser () {
      return true;
    }
  },
  created () {
    this.getAnnouncements();
  },
  methods: {
    filterAnnouncementsByCategory () {
      this.filteredAnnouncements = this.targetedAnnouncements.filter(item => item.title.toLowerCase().includes(this.searchText.toLowerCase()) && `${this.targetSelect}`.includes(item.target) && item.category === this.categorySelect);
    },
    searchAnnouncement () {
      this.hidePages = true;
      if (this.searchText.length > 2) {
        this.filterAnnouncementsByCategory();
      } else {
        this.filteredAnnouncements = this.targetedAnnouncements;
      }
    },
    getAnnouncements () {
      this.filteredAnnouncements = [];
      axios.get(`/GetAnnouncementsByTarget/${this.targetSelect}/${this.page}`).then(res => {
        this.targetedAnnouncements = res.data;
        this.filteredAnnouncements = this.targetedAnnouncements;
        this.totalPages = Math.ceil(this.targetedAnnouncements.length / 6);
      }).catch(error => {
        console.error('Error fetching announcements:', error);
      });
    }
  },
  components: { ButtonVue, AnnouncementCardVue }
}
</script>

<style scoped lang="scss">
.announcements-page {
  background: #f9fafb;
  color: #1f2937;
  min-height: 100vh;
}

.container {
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}

.section {
  padding: 40px 0;
}

.section--filters {
  padding-bottom: 20px;
}

.section--content {
  padding-top: 20px;
}

.section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

.section__head h2 {
  margin: 0;
}

.search-announcement {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto auto;
  gap: 12px;
  padding: 16px;
  align-items: stretch;
}

.search-announcement input,
.search-announcement select {
  padding: 2px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background-color: #fff;
  color: #1f2937;
  min-height: 42px;
}

.target-choose {
  display: grid;
  gap: 8px;
}

.filter-btn {
  cursor: pointer;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-weight: 600;
}

.filter-btn--primary {
  background: #10b981;
  color: #fff;
  border-color: #10b981;
}

.filter-btn:hover {
  border-color: #10b981;
}

.announcement-page {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}

.announcement-pagination{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 16px 0 22px;
  &__arrow{
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 8px;
    background: #10b981;
    color: #fff;
    cursor: pointer;
    font-size: 2rem;
    line-height: 1;
  }
  &__arrow:disabled{
    opacity: .4;
    cursor: not-allowed;
  }
}

.announcements-container {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.empty-state {
  margin: 16px 0 8px;
  min-height: 320px;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  color: #6b7280;
  padding: 24px;
}

.empty-state__icon {
  width: 74px;
  height: 74px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #10b981;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.12);
}

.empty-state__icon svg {
  width: 38px;
  height: 38px;
  fill: currentColor;
}

.empty-state h3 {
  margin: 4px 0 0;
  color: #374151;
}

.empty-state p {
  margin: 0;
  max-width: 420px;
  font-size: 1.25rem;
}

.not-logged-in {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.not-logged-in h2 {
  margin: 0;
}

.not-logged-in p {
  margin: 0;
  color: #6b7280;
}

.not-logged-in div {
  display: flex;
  justify-content: center;
  gap: 16px;
}

@media (max-width: 1024px) {
  .search-announcement {
    grid-template-columns: 1fr 1fr;
  }

  .search-announcement input {
    grid-column: 1 / -1;
  }

  .announcements-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .section {
    padding: 28px 0;
  }

  .search-announcement {
    grid-template-columns: 1fr;
  }

  .not-logged-in div {
    flex-direction: column;
    width: 100%;
  }

  .announcements-container {
    grid-template-columns: 1fr;
  }
}
</style>